
import React from "react";
import { Campaign } from "./CampaignModal";
import CampaignMetricsCards from "./results/CampaignMetricsCards";
import RevenueBarChart from "./results/RevenueBarChart";
import CampaignAuditLog from "./CampaignAuditLog";
import CampaignRulesPreview from "./CampaignRulesPreview";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface CampaignResultsProps {
  campaign: Campaign;
}

const CampaignResults = ({ campaign }: CampaignResultsProps) => {
  // Mock data for now - in a real app, this would come from a hook that fetches campaign metrics
  const mockMetrics = {
    totalConversions: 0,
    totalRevenue: 0,
    totalCoupons: 0,
    totalReferrals: 0,
    conversionRate: 0,
    averageOrderValue: 0
  };

  const mockRevenueData = [
    { date: "2024-01-01", receita: 0 },
    { date: "2024-01-02", receita: 0 },
    { date: "2024-01-03", receita: 0 }
  ];

  return (
    <div className="space-y-6">
      <CampaignMetricsCards 
        totalConversions={mockMetrics.totalConversions}
        totalRevenue={mockMetrics.totalRevenue}
        totalCoupons={mockMetrics.totalCoupons}
        totalReferrals={mockMetrics.totalReferrals}
        conversionRate={mockMetrics.conversionRate}
        averageOrderValue={mockMetrics.averageOrderValue}
      />
      
      <Tabs defaultValue="metrics" className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="metrics">Métricas</TabsTrigger>
          <TabsTrigger value="rules">Regras</TabsTrigger>
          <TabsTrigger value="logs">Auditoria</TabsTrigger>
          <TabsTrigger value="automation">Automação</TabsTrigger>
        </TabsList>
        
        <TabsContent value="metrics" className="mt-4">
          <RevenueBarChart data={mockRevenueData} />
        </TabsContent>
        
        <TabsContent value="rules" className="mt-4">
          <CampaignRulesPreview campaignId={campaign.id} />
        </TabsContent>
        
        <TabsContent value="logs" className="mt-4">
          <CampaignAuditLog campaignId={campaign.id} />
        </TabsContent>
        
        <TabsContent value="automation" className="mt-4">
          <div className="space-y-4">
            <div className="p-4 border rounded-lg bg-muted/50">
              <h3 className="font-medium mb-2">Status da Automação</h3>
              <p className="text-sm text-muted-foreground mb-3">
                Esta campanha é gerenciada automaticamente pelo sistema baseado nas datas de início e fim.
              </p>
              <div className="space-y-2 text-sm">
                <div>
                  <strong>Data de Início:</strong> {new Date(campaign.start_date).toLocaleDateString('pt-BR')}
                </div>
                <div>
                  <strong>Data de Fim:</strong> {new Date(campaign.end_date).toLocaleDateString('pt-BR')}
                </div>
                <div>
                  <strong>Status Atual:</strong> {campaign.status === 'active' ? 'Ativa' : 
                                                    campaign.status === 'scheduled' ? 'Agendada' : 
                                                    campaign.status === 'completed' ? 'Finalizada' : 'Rascunho'}
                </div>
              </div>
            </div>
            
            <div className="p-4 border rounded-lg">
              <h3 className="font-medium mb-2">Processos Automáticos</h3>
              <ul className="text-sm space-y-1 text-muted-foreground">
                <li>• Campanhas agendadas são ativadas automaticamente na data de início</li>
                <li>• Regras de cashback/referral são aplicadas quando a campanha é ativada</li>
                <li>• Campanhas ativas são finalizadas automaticamente na data de fim</li>
                <li>• Regras são revertidas quando a campanha é finalizada</li>
                <li>• O sistema executa verificações diárias às 00:01</li>
              </ul>
            </div>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default CampaignResults;
